module.exports = __webpack_public_path__ + "static/media/5_portrait.7ecf4c8d.jpg";